module.exports = __webpack_public_path__ + "static/media/templates.8585d395.svg";